import { Box } from "@mui/material";
import { useDispatch } from "react-redux";
import { isNil } from "lodash";
import { opacityDisabled, pointerEventsDisabled } from "../../../core/helpers/disableHelper";


export interface SettingsActivatedButtonProps {
    name: string
    value: boolean
    setter: any,
    additionalOnClick?: () => void
    disabled?: boolean

}

const SettingsActivatedButton = (props: SettingsActivatedButtonProps) => {

    let dispatch = useDispatch();
    return <Box width={170} textAlign={"center"} margin={1} sx={{opacity: opacityDisabled(props.disabled), pointerEvents: pointerEventsDisabled(props.disabled), border: "solid 1px", borderRadius: "5px",cursor: "pointer", filter: !props.value ? "brightness(0.5)" : "inherit", textDecoration: !props.value ? "line-through" : "inherit"}} 
                onClick={() => {
                        dispatch(props.setter(!props.value)); 
                        if(!isNil(props.additionalOnClick))
                            props.additionalOnClick?.()
                    }}
                    >{props.name}</Box>
}

export default SettingsActivatedButton;



